// Window-button behaviour as a hook, so ANY button (including ones designed in
// Plasmic, like OP1WebAWButton and ButtonPrimary) can drive a Desktop window.
//
// UX rules (build review NOV.01.2026):
//   - An AppWindow is either VISIBLE or NOT VISIBLE - there is no
//     "minimized but still running" state like on a desktop OS.
//   - One click opens the window; a second click closes it (state -> closed).
//
// state: "closed" (not visible) | "open" (visible, not the active window) |
//        "active" (visible and the active/focused window)
//
// With no `windowId` (or no DesktopStateProvider above) it is inert:
// `enabled` is false and handleClick does nothing.
import { useOptionalDesktopState } from "./DesktopStateProvider";

export default function useWindowButton(windowId) {
  const ctx = useOptionalDesktopState();
  const enabled = !!(windowId && ctx);
  const win = enabled ? ctx.state.windows[windowId] : undefined;

  // A minimized window counts as not visible -> "closed".
  const isOpen = !!win?.isOpen && !win?.isMinimized;
  const isFocused = isOpen && !!win?.isFocused;

  let state = "closed";
  if (isOpen) state = isFocused ? "active" : "open";

  const handleClick = () => {
    if (!enabled) return;
    const { actions } = ctx;
    if (isOpen) actions.closeWindow(windowId);
    else actions.openWindow(windowId);
  };

  return { enabled, state, isOpen, isFocused, handleClick };
}
